import { RECORD_TASK_TYPE } from '../../data/user_record/record_task_type';
import {
    API_POST_ADD_USER_RECORD,
    API_POST_UPDATE_USER_RECORD,
    API_POST_DELETE_USER_RECORD,
    API_UPLOAD_RECORD_IMAGE
} from '../api';

import { mergeTask } from './task_store';
import AppRenderer from '../app_renderer';
import { useUserStore } from '../user_data';
import { store } from '../../store';
import SaveTool from '../toolbar/save_tool';
import BookData from '../book_data';
import ImageControl from './image_control';
import { VIEW_TYPE } from '../view_type';
import { FILE_TO_BYTE_ARRAY } from '../common/file_parse';

export default class TaskControl {

    /**
     *
     * @type {TaskControl}
     * @static
     * @memberof TaskControl
     */
    static _instance = null;


    /**
     *
     * @type {Array<{check:boolean, taskName: String, taskType: string, updateTime: any}>}}
     * @memberof TaskControl
     */
    tasks = [];

    currentTask = 0;

    constructor() {

    }

    /**
     * Instance
     * @type {TaskControl}
     * @readonly
     * @static
     * @memberof TaskControl
     */
    static get Instance() {
        if (this._instance == null) {
            this._instance = new TaskControl();
        }
        return this._instance;
    }

    startMerge() {
        this.currentTask = 0;

        this.doTask();
    }

    async doTask() {
        if (mergeTask.tasks[this.currentTask].check) {
            await this.getTask(mergeTask.tasks[this.currentTask]);
        } else {
            mergeTask.tasks[this.currentTask].result = "ignore";
        }
        this.currentTask++;
        console.log("current task:", this.currentTask, "all tasks count: ", mergeTask.tasks.length);
        if (this.currentTask < mergeTask.tasks.length) {
            console.log("do next task");
            this.doTask();
        } else {
            console.log("finish all tasks");

        }
    }

    /**
     *
     * @type 
     * @param {{check:boolean, taskName: String, taskType: string, updateTime: any}} task
     * @memberof TaskControl
     */
    async getTask(task) {
        let finishTask = null;
        switch (task.taskType) {
            case RECORD_TASK_TYPE.UPLOAD_TO_CLOUD:
                finishTask = await this.uploadTask(task);
                break;
            case RECORD_TASK_TYPE.UPDATE_TO_CLOUD:
                finishTask = await this.uploadTask(task);
                break;
            case RECORD_TASK_TYPE.DOWNLOAD_FROM_CLOUD:
                await this.downloadTask(task);
                break;
            case RECORD_TASK_TYPE.UPDATE_FROM_CLOUD:
                await this.downloadTask(task);
                break;
            case RECORD_TASK_TYPE.DELETE_CLOUD:
                await this.deleteTask(task);
                break;
            case RECORD_TASK_TYPE.DELETE_LOCAL:
                await this.deleteTask(task);
                break;
        }
    }

    /**
     *
     *
     * @param {{check:boolean, taskName: String, taskType: string, updateTime: any, url: string}} task
     * @memberof TaskControl
     */
    async uploadTask(task, recordData = null) {
        console.log("upload task:", task);
        let response;
        if (task.url) response = await fetch(task.url);
        let data;
        if (recordData != null) {
            data = recordData;
        } else {
            data = await response.text();
        }

        console.log("task url:", task.url);

        const jsonData = JSON.parse(data);
        
        const images = jsonData.images;

        const USER_DATA = useUserStore();

        let item = {
            log_name: task.taskName,
            book_id: BookData.Instance.BookId,
            user_id: USER_DATA.userId,
            update_time: task.updateTime,
            data: data
        }
        
        let upload;
        let needImages = [];
        if (task.log_id) {
            if (task.cloud_url) {
                const oldResponse = await fetch(task.cloud_url);
                const oldData = await oldResponse.json();
    
                const oldImages = oldData.images;
    
                for(let i = 0; i < images.length; i++) {
                    if(!oldImages.includes(images[i])) {
                        needImages.push(images[i]);
                    }
                }
    
                if(needImages.length > 0) {
                    console.log("need to upload:", needImages);
                }else {
                    console.log(`no image need to upload`);
                }
            }

            if (needImages.length == 0) {
                needImages = images;
            }

            upload = await API_POST_UPDATE_USER_RECORD(item);
        } else {
            needImages = images;
            upload = await API_POST_ADD_USER_RECORD(item);
        }
        let result = await upload.json();

        console.log(result);
        if (result.success) {
            store.mergeToCloud = false;
            // SaveTool._instance.showFinish(result.success);
        }
        
        // 開始上傳需要的圖片
        const uploadImages = [];
        needImages.forEach((image) => {
            if(store.nowView == VIEW_TYPE.WEB) {
                uploadImages.push(this.uploadImageFromFile(item.log_name, image));
            }else {
                const imageFolder = task.url.split(".json")[0];
                uploadImages.push(this.uploadImage(item.log_name, imageFolder, image));
            }
        });

        const uploadImageResult = await Promise.all(uploadImages);

        console.log("upload image result::", uploadImageResult);

        task.result = "success";
        return result;

    }
    /**
     *
     *
     * @param {{check:boolean, taskName: String, taskType: string, updateTime: any, url: string}} task
     * @memberof TaskControl
     */
    async downloadTask(task) {
        console.log(task);

        let response = await fetch(task.url);
        let data = await response.text();

        let jsonData = JSON.parse(data);
        
        const baseUrl = task.url.split(".json")[0];

        const images = jsonData.images || [];

        images.forEach(image => {
            const url = `${baseUrl}/${image}`;
            this.downloadImage(task.taskName, url, image);
        });
        console.log(data);

        if (task.taskType == RECORD_TASK_TYPE.DOWNLOAD_FROM_CLOUD) {
            AppRenderer.Instance.saveCloudRecord(task.taskName, task.updateTime, data);
        } else if (task.taskType == RECORD_TASK_TYPE.UPDATE_FROM_CLOUD) {
            AppRenderer.Instance.updateCloudRecord(task.log_id, task.updateTime, data);
        }


    }
    /**
     * 
     * @param {{check:boolean, taskName: String, taskType: string, updateTime: any, url: string}} task 
     */
    async deleteTask(task) {
        console.log("task: ", task);

        if (task.taskType == RECORD_TASK_TYPE.DELETE_CLOUD) {
            const USER_DATA = useUserStore();
            let item = {
                log_name: task.taskName,
                book_id: BookData.Instance.BookId,
                user_id: USER_DATA.userId,
                update_time: task.updateTime
            }

            let response = await API_POST_DELETE_USER_RECORD(item);
            let result = await response.json();

            if (result.content) {
                task.result = "success";
            } else {
                task.result = "fail";
            }

        } else if (task.taskType == RECORD_TASK_TYPE.DELETE_LOCAL) {
            AppRenderer.Instance.deleteRecord(task.log_id, task.taskName, task.url, task.updateTime);
        }
    }
    /**
     * 
     * @param {string} taskName 
     * @param {string} imageName 
     * @param {byte[]} file 
     * @returns 
     */
    async uploadImage(taskName, imageFolder, imageName) {
        const USER_DATA = useUserStore();

        const response = await fetch(`${imageFolder}/${imageName}`);
        const file = Array.from(new Uint8Array(await response.arrayBuffer()));

        const item = {
            "log_name": taskName,
            "book_id": BookData.Instance.BookId,
            "user_id": USER_DATA.userId,
            "image_name": imageName,
            "file": file
        }
        return API_UPLOAD_RECORD_IMAGE(JSON.stringify(item));
    }

    /**
     * 
     * @param {string} taskName 
     * @param {string} imageFolder 
     * @param {string} imageName 
     * @returns 
     */
    async uploadImageFromFile(taskName, imageName) {
        const USER_DATA = useUserStore();
        const fileForRead = ImageControl.Instance.imageFiles.get(imageName);
        const file = Array.from(await FILE_TO_BYTE_ARRAY(fileForRead));

        const item = {
            "log_name": taskName,
            "book_id": BookData.Instance.BookId,
            "user_id": USER_DATA.userId,
            "image_name": imageName,
            "file": file
        }

        return API_UPLOAD_RECORD_IMAGE(JSON.stringify(item));
    }

    async downloadImage(taskName, url, imageName) {
        const response = await fetch(url);
        const data = new Uint8Array(await response.arrayBuffer());

        AppRenderer.Instance.saveImage(BookData.Instance.BookId, taskName, imageName, data);
    }
}